// @flow
import {ROUTE} from 'app/constants/route';
import cn from 'classnames';
import {selectIsStudent} from 'modules/auth/selectors/auth';
import {CustomScrollbars} from 'modules/common/components/CustomScrollBar';
import React from 'react';
import {useIntl} from 'react-intl';
import {useSelector} from 'react-redux';
import {NavLink} from 'react-router-dom';
import styles from './styles.local.less';

type TProps = {
    children: React$Node,
    closeMenu: () => void,
    showMenu?: boolean,
};

/**
 * Контент типовых страниц
 * @returns React-компонент
 */
export const PageContent = ({children, closeMenu, showMenu}: TProps) => {
    const intl = useIntl();
    const isStudent = useSelector(selectIsStudent);
    return (
        <div className={styles.pageContent}>
            {!isStudent && (
                <>
                    <button className={cn(styles.menuBackground, {[styles.menuBackgroundShow]: showMenu})} onClick={closeMenu} />
                    <div className={cn(styles.pageContentMenu, {[styles.showMenu]: showMenu})}>
                        <NavLink activeClassName={styles.pageContentLinkActive} className={styles.pageContentLink} to={`/${ROUTE.DASHBOARD}`}>
                            {intl.formatMessage({defaultMessage: 'Дашборд', id: 'common.pageContent.dashboard'})}
                        </NavLink>
                        <NavLink activeClassName={styles.pageContentLinkActive} className={styles.pageContentLink} to={`/${ROUTE.TRAINING_MODULE}`}>
                            {intl.formatMessage({defaultMessage: 'Модули', id: 'common.pageContent.modules'})}
                        </NavLink>
                        <NavLink activeClassName={styles.pageContentLinkActive} className={styles.pageContentLink} to={`/${ROUTE.USERS}`}>
                            {intl.formatMessage({defaultMessage: 'Пользователи', id: 'common.pageContent.users'})}
                        </NavLink>
                        <NavLink activeClassName={styles.pageContentLinkActive} className={styles.pageContentLink} to={`/${ROUTE.LICENSE}`}>
                            {intl.formatMessage({defaultMessage: 'Лицензии', id: 'common.pageContent.license'})}
                        </NavLink>
                    </div>
                </>
            )}
            <div className={cn(styles.pageContentBody, {[styles.pageContentBodyIsStudent]: isStudent})}>
                <CustomScrollbars>
                    <div className={styles.pageContentBodyWrapper}>{children}</div>
                </CustomScrollbars>
            </div>
        </div>
    );
};
